const generateKey = () => {
    const crypto = window.crypto || window.msCrypto;
    var array = new Uint32Array(1);
    return crypto?.getRandomValues(array)[0] ?? "abc123";
}

const randomString = generateKey()

const baseUrlApi = process.env.REACT_APP_API_URL
const languageBaseUrlApi = process.env.REACT_APP_LANGUAGE_API_URL
const appId = process.env.REACT_APP_APP_ID
const key = randomString
const AesSecretKey = process.env.REACT_APP_AES_KEY

export {
    baseUrlApi,
    languageBaseUrlApi,
    appId,
    key,
    AesSecretKey
}